
import { defineComponent, computed, getCurrentInstance, PropType } from 'vue';
import Tabs from 'vant/lib/tabs';
import Tab from 'vant/lib/tab';
import { getQuery } from '~/common/utils';

enum AITopTabsEnum {
    AI = 0,
    FOR_YOU = 1,
}

const TopTabs = defineComponent({
    components: {
        vanTabs: Tabs,
        vanTab: Tab,
    },
    props: {
        currentIndex: {
            type: Number,
            default: 0,
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const activeIndex = computed(() => {
            const currentPath = window.location.pathname;
            return currentPath?.includes('aichat') ? AITopTabsEnum.AI : AITopTabsEnum.FOR_YOU;
        });
        const onClick = (index: number) => {
            const query = getQuery();
            if (index === 0) {
                proxy.$router.push({ path: '/aichat', query: { ...query, extra_info: index } });
            } else {
                proxy.$router.push({ path: '/foryou', query: { ...query, extra_info: index } });
            }
        };
        return { onClick, activeIndex };
    },
});

export default TopTabs;
